





import Vue from 'vue';
import Component from 'vue-class-component';
import TheToolbar from './TheToolbar'

import DownloadManager from '@/components/DownloadManager/DownloadManager'
@Component({
    components: {
        TheToolbar,
        DownloadManager
    }
})
export default class TheToolbarContainer extends Vue {
}
